import { all, call, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import { ExperimentsAction, PerformanceTabQuery } from 'modules/experiments/types';
import { addToRootSaga } from 'store';

import { setBasePageDataSaga } from './basePageSaga';
import { setI18nTranslationSaga } from './i18nSaga';
import { setAnalyticsMetricsDataSaga } from './metricsSaga';
import { setPerformanceTabDataSaga } from './performanceTabSaga';
import { setOverviewTabDataSaga } from './overviewTabSaga';

export { setBasePageDataSaga } from './basePageSaga';
export { setI18nTranslationSaga } from './i18nSaga';
export { setAnalyticsMetricsDataSaga } from './metricsSaga';
export { setOverviewTabDataSaga } from './overviewTabSaga';
export { setPerformanceTabDataSaga } from './performanceTabSaga';

addToRootSaga([
  takeLatest(ActionTypes.ANALYTICS_PAGE_LOADED, function* pageLoadSagas(action) {
    try {
      yield all([
        call(setBasePageDataSaga, action as ExperimentsAction<{ experimentId: number }>),
        call(setI18nTranslationSaga),
      ]);
    } catch (e) {
      // Do nothing
    }
  }),
  takeLatest(
    [
      ActionTypes.ANALYTICS_PAGE_PERFORMANCE_TAB_LOADED,
      ActionTypes.ANALYTICS_RELOAD_PERFORMANCE_TAB_DATA,
    ],
    function* performanceTabLoadSagas(action) {
      if (action.type === ActionTypes.ANALYTICS_RELOAD_PERFORMANCE_TAB_DATA) {
        // While reloading just reload the metric table info
        yield setPerformanceTabDataSaga(
          action as ExperimentsAction<{ queryData: PerformanceTabQuery }>,
        );
      } else {
        try {
          yield all([
            call(
              setPerformanceTabDataSaga,
              action as ExperimentsAction<{ queryData: PerformanceTabQuery }>,
            ),
            call(
              setAnalyticsMetricsDataSaga,
              action as ExperimentsAction<{ queryData: PerformanceTabQuery }>,
            ),
          ]);
        } catch (e) {
          // Do nothing
        }
      }
    },
  ),
  takeLatest(
    [
      ActionTypes.ANALYTICS_PAGE_OVERVIEW_TAB_LOADED,
      ActionTypes.ANALYTICS_RELOAD_OVERVIEW_TAB_DATA,
    ],
    function* overviewTabLoadSagas(action) {
      yield setOverviewTabDataSaga(action as ExperimentsAction<{ experimentId: number }>);
    },
  ),
]);
